import { motion } from "framer-motion";

interface FloatingOfferButtonProps {
  isScrolled: boolean;
}

const FloatingOfferButton = ({ isScrolled }: FloatingOfferButtonProps) => {
  return (
    <motion.a
      href="/#"
      className="hidden md:block bg-red-600 hover:bg-red-700 text-white font-['Raleway'] font-bold text-[17px] py-[15px] px-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 whitespace-nowrap"
      initial={{ x: '100%', opacity: 0 }}
      animate={{ 
        x: isScrolled ? 0 : '100%',
        opacity: isScrolled ? 1 : 0,
        pointerEvents: isScrolled ? 'auto' : 'none'
      }}
      transition={{ 
        type: 'tween',
        duration: 0.4,
        ease: [0.25, 0.1, 0.25, 1]
      }}
      whileHover={{ 
        scale: 1, // prevent text resizing/glitching
        boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
      }}
      whileTap={{ scale: 0.98 }}
    >
      FÅ GRATIS OFFERT
    </motion.a>
  );
};

export default FloatingOfferButton;
